module.exports = "<p style=\"text-align: center\">Pagina Help Template FreeMaker</p>"